var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBrandWhite(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 105.142,
    height: 25.488,
    viewBox: "0 0 105.142 25.488",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.909 0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M38.951,10.179a5.424,5.424,0,0,1-1.182,2.556,4.919,4.919,0,0,1-2.431,1.549l3.294,6.144H33.824l-2.5-5.741-1.3.005-1.08,5.735H24.71L27.551,5.32h7.044a4.3,4.3,0,0,1,3.573,1.448A4.018,4.018,0,0,1,38.951,10.179Zm-8.43,1.88h1.521q2.391,0,2.763-1.985.4-2.136-1.966-2.136H31.3Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.319,15.266q-.027.227-.027.3a2.546,2.546,0,0,0,.784,1.977,3.249,3.249,0,0,0,2.271.718,6.308,6.308,0,0,0,3.692-1.108l-.425,2.392a8.467,8.467,0,0,1-4.675,1.183,5.369,5.369,0,0,1-4.117-1.586,5.1,5.1,0,0,1-1.328-4A5.9,5.9,0,0,1,40.619,10.9a6.653,6.653,0,0,1,4.436-1.649,5.281,5.281,0,0,1,3.506,1.133,3.312,3.312,0,0,1,1.2,3,6.349,6.349,0,0,1-.4,1.888Zm4.223-2.442a1.27,1.27,0,0,0-.332-1.02,1.464,1.464,0,0,0-1.129-.416q-1.674,0-2.417,2.191H46.33A1.967,1.967,0,0,0,46.542,12.823Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.767,20.427l1.594-8.586H49.528l.425-2.291h1.833l.032-.175q.664-4.458,5.761-4.458a12.5,12.5,0,0,1,2.735.4l3.956-.352-2.862,15.46H57.444L59.829,7.535a5.336,5.336,0,0,0-1.907-.352,2,2,0,0,0-1.43.454,2.656,2.656,0,0,0-.662,1.486l-.079.427h2.311l-.452,2.291H55.325l-1.594,8.586Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.937,15.266q-.027.227-.027.3a2.546,2.546,0,0,0,.784,1.977,3.249,3.249,0,0,0,2.271.718,6.308,6.308,0,0,0,3.692-1.108l-.425,2.392a8.467,8.467,0,0,1-4.675,1.183,5.369,5.369,0,0,1-4.117-1.586,5.1,5.1,0,0,1-1.328-4A5.9,5.9,0,0,1,65.237,10.9a6.653,6.653,0,0,1,4.436-1.649,5.281,5.281,0,0,1,3.506,1.133,3.311,3.311,0,0,1,1.2,3,6.346,6.346,0,0,1-.4,1.888Zm4.224-2.442a1.27,1.27,0,0,0-.332-1.02,1.465,1.465,0,0,0-1.129-.416q-1.674,0-2.417,2.191h3.666A1.965,1.965,0,0,0,71.161,12.823Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.279,9.55l-4.967,5.338,3.214,5.539H81.435l-2-3.5-3.158,3.5H72.271L77.5,14.812l-3-5.262h4.091L80.371,12.8l2.95-3.247Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.04,15.266q-.027.227-.027.3a2.545,2.545,0,0,0,.784,1.977,3.248,3.248,0,0,0,2.271.718,6.308,6.308,0,0,0,3.692-1.108l-.425,2.392a8.467,8.467,0,0,1-4.675,1.183,5.369,5.369,0,0,1-4.117-1.586,5.1,5.1,0,0,1-1.328-4A5.9,5.9,0,0,1,87.34,10.9a6.653,6.653,0,0,1,4.436-1.649,5.281,5.281,0,0,1,3.506,1.133,3.312,3.312,0,0,1,1.2,3,6.346,6.346,0,0,1-.4,1.888Zm4.224-2.442a1.27,1.27,0,0,0-.332-1.02,1.464,1.464,0,0,0-1.129-.416q-1.674,0-2.417,2.191h3.666A1.967,1.967,0,0,0,93.264,12.823Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.051,9.248l-.77,4.1a3,3,0,0,0-1.2-.252q-2.663,0-3.267,3.192l-.764,4.135H96.116l1.394-7.551A22.286,22.286,0,0,0,97.9,9.55h3.745a10.754,10.754,0,0,1-.082,1.989,5.217,5.217,0,0,1,1.836-1.7A4.758,4.758,0,0,1,106.051,9.248Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.914,0h-2.42L9.367,10.325l.042.02a2.758,2.758,0,0,1,.819.665q.085.1.159.21a2.721,2.721,0,0,1,.377,2.29c0,.011-.005.023-.008.033a2.717,2.717,0,0,1-.171.434c-.008.016-.015.033-.023.049a2.737,2.737,0,0,1-.237.378l-.038.052a2.766,2.766,0,0,1-.295.32l-.051.047a2.776,2.776,0,0,1-.345.261l-.059.036a2.751,2.751,0,0,1-.391.2l-.06.023a2.729,2.729,0,0,1-.432.125l-.054.009a2.967,2.967,0,0,1-.3.028L6.736,23.092H10.88L15.291,1.685A1.4,1.4,0,0,0,13.914,0Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.591,15.058a2.756,2.756,0,0,1-.411-.334Q6.086,14.632,6,14.53a2.766,2.766,0,0,1-.3-.435q-.064-.116-.117-.238A2.726,2.726,0,0,1,5.361,12.8a2.691,2.691,0,0,1,.1-.774c0-.011.005-.022.008-.033a2.716,2.716,0,0,1,.171-.434c.008-.016.015-.033.023-.048a2.74,2.74,0,0,1,.237-.377l.038-.052a2.758,2.758,0,0,1,.295-.321l.051-.047a2.755,2.755,0,0,1,.345-.261l.059-.036a2.751,2.751,0,0,1,.391-.2l.061-.023a2.725,2.725,0,0,1,.432-.125l.054-.009a2.96,2.96,0,0,1,.312-.03L9.515,2.4H5.372L.96,23.8a1.4,1.4,0,0,0,1.376,1.685h2.42L6.874,15.217c-.017-.009-.037-.013-.054-.022Q6.7,15.132,6.591,15.058Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.665,13.824a2.633,2.633,0,0,1-.2-.753A2.633,2.633,0,0,0,5.665,13.824Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.463,13.07a2.634,2.634,0,0,1-.017-.266A2.622,2.622,0,0,0,5.463,13.07Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.547,12.052c0-.01,0-.021.008-.031C5.552,12.031,5.55,12.042,5.547,12.052Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.721,11.6c.008-.015.015-.031.023-.047C5.735,11.569,5.728,11.585,5.721,11.6Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.973,11.188l.038-.05Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.256,14.352l-.038.05Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.637,15.379l-.053.008Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.934,14.712l-.05.045Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.295,10.827l.05-.045Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.114,15.235l-.059.021Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.068,14.475a2.675,2.675,0,0,1-.29-.421A2.675,2.675,0,0,0,6.068,14.475Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.638,14.987a2.673,2.673,0,0,1-.4-.323A2.673,2.673,0,0,0,6.638,14.987Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.118,15.43h.01c-.084,0-.168,0-.253-.009Q8,15.43,8.118,15.43Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.345,15.318a2.653,2.653,0,0,1-.485-.2A2.653,2.653,0,0,0,7.345,15.318Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.623,10.157a2.673,2.673,0,0,1,.509.151A2.673,2.673,0,0,0,8.623,10.157Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.55,15.01l-.057.035Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.681,13.486c0,.01,0,.021-.008.031C10.677,13.507,10.678,13.5,10.681,13.486Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.316,11.268a2.663,2.663,0,0,1,.249.448A2.656,2.656,0,0,0,10.316,11.268Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.111,10.108H8.1c.084,0,.168,0,.253.009Q8.231,10.108,8.111,10.108Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.161,11.063a2.668,2.668,0,0,0-.793-.643A2.668,2.668,0,0,1,10.161,11.063Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.114,10.3l.059-.021Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.592,10.16l.053-.008Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.509,13.939c-.008.015-.015.031-.023.047C10.494,13.97,10.5,13.954,10.509,13.939Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.679,10.529l.057-.035Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.645,8.162A7.163,7.163,0,0,0,8.759,5.609c-.215-.019-.433-.029-.648-.029a7.189,7.189,0,0,0-.642,14.35c.215.019.433.029.648.029a7.186,7.186,0,0,0,5.527-11.8Zm-2.874,4.846a2.668,2.668,0,0,1-.089.478c0,.011,0,.022-.008.032a2.631,2.631,0,0,1-.165.42c-.008.016-.014.032-.022.047a2.656,2.656,0,0,1-.23.366l-.037.05a2.66,2.66,0,0,1-.286.311l-.049.045a2.683,2.683,0,0,1-.335.253l-.057.035a2.661,2.661,0,0,1-.378.19l-.059.022a2.661,2.661,0,0,1-.419.121l-.052.008a2.652,2.652,0,0,1-.457.043h-.01q-.12,0-.242-.011a2.683,2.683,0,0,1-.531-.1,2.651,2.651,0,0,1-.485-.2q-.115-.061-.222-.132a2.669,2.669,0,0,1-.4-.323q-.091-.09-.173-.188a2.675,2.675,0,0,1-.289-.421q-.062-.112-.113-.231a2.641,2.641,0,0,1-.218-1.02,2.607,2.607,0,0,1,.1-.75c0-.011,0-.022.008-.032A2.629,2.629,0,0,1,5.72,11.6c.008-.016.014-.032.022-.047a2.644,2.644,0,0,1,.23-.366l.037-.05a2.662,2.662,0,0,1,.286-.311l.049-.045a2.673,2.673,0,0,1,.335-.253l.057-.035a2.671,2.671,0,0,1,.378-.19l.059-.022a2.646,2.646,0,0,1,.419-.121l.052-.009a2.662,2.662,0,0,1,.457-.043h.01q.12,0,.242.011a2.706,2.706,0,0,1,.27.038,2.663,2.663,0,0,1,.509.152q.121.05.236.111a2.669,2.669,0,0,1,.793.644q.082.1.155.2a2.648,2.648,0,0,1,.455,1.74Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.486,13.986a2.651,2.651,0,0,1-.23.365A2.641,2.641,0,0,0,10.486,13.986Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.885,14.757a2.679,2.679,0,0,1-.335.252A2.678,2.678,0,0,0,9.885,14.757Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.22,14.4a2.675,2.675,0,0,1-.286.31A2.675,2.675,0,0,0,10.22,14.4Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.771,13.008a2.653,2.653,0,0,1-.09.477A2.653,2.653,0,0,0,10.771,13.008Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.674,13.519a2.62,2.62,0,0,1-.166.42A2.62,2.62,0,0,0,10.674,13.519Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.173,10.281a2.674,2.674,0,0,1,.419-.12A2.663,2.663,0,0,0,7.173,10.281Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.736,10.493a2.676,2.676,0,0,1,.378-.189A2.676,2.676,0,0,0,6.736,10.493Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.009,11.138a2.673,2.673,0,0,1,.286-.31A2.669,2.669,0,0,0,6.009,11.138Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.344,10.782a2.688,2.688,0,0,1,.335-.252A2.688,2.688,0,0,0,6.344,10.782Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.644,10.152a2.712,2.712,0,0,1,.457-.042A2.712,2.712,0,0,0,7.644,10.152Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.547,12.054a2.6,2.6,0,0,0-.1.75A2.6,2.6,0,0,1,5.547,12.054Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.492,15.045a2.676,2.676,0,0,1-.378.189A2.665,2.665,0,0,0,9.492,15.045Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.584,15.387a2.713,2.713,0,0,1-.457.042A2.712,2.712,0,0,0,8.584,15.387Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.055,15.257a2.667,2.667,0,0,1-.419.12A2.666,2.666,0,0,0,9.055,15.257Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.555,12.021a2.616,2.616,0,0,1,.166-.42A2.616,2.616,0,0,0,5.555,12.021Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.743,11.554a2.648,2.648,0,0,1,.231-.365A2.639,2.639,0,0,0,5.743,11.554Z",
    fill: "#fff"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBrandWhite);
export default __webpack_public_path__ + "static/media/brand-white.87373ece5d54fb3b7ad1036ccca6e80e.svg";
export { ForwardRef as ReactComponent };